export default __webpack_public_path__ + "static/media/wallet-blue.d3cc60e8.svg";